import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { UserCalendarUrl } from '../../UserDashboardUrl';
import { LatestCommentsType } from '../schema/types';

const getLatestComments = () =>
  apiClient
    .get<LatestCommentsType[]>(expand(UserCalendarUrl.LATEST_COMMENTS), {})
    .then((response) => response.data);

export const useListLatestCommentsQuery = createApiQueryHook(
  ['latestComments'],
  getLatestComments,
);
